import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mappedChargebacksRecommendationData } from "mappers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateChargebackRecommendationMutation = (
	chargebackId: string,
	refetchRecommendationInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
		}: {
			formValues: { [key: string]: any };
			setActionFormState?: Function;
		}) => {
			return chargebacksDetailsService.updateRecommendationInfo(
				chargebackId,
				mappedChargebacksRecommendationData(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				refetchRecommendationInfo?.();
				setActionFormState?.(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateChargebackRecommendationMutation;
